// This file is auto-generated.
// It's responsible for giving the view it's own Flow context.

import { Flow } from 'Simple/Flow'
import React from 'react'
import InlineNoteEditor from './logic'

export default function InlineNoteEditorFlow({ children, ...props }) {
  return (
    <Flow viewPath={props.viewPath} flowDefinitionViewPathSource="/DesignSystem/InlineNoteEditor">
      <InlineNoteEditor {...props}>
        {children}
      </InlineNoteEditor>
    </Flow>
  )
}
